export const pageTitleSx = {
  color: '#424242',
  fontSize: 16,
  fontWeight: 500,
  mb: 2
};

export const cardSx = {
  bgcolor: '#FFFFFF',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.16)',
  overflow: 'hidden'
};

export const cardHeaderSx = {
  alignItems: 'center',
  bgcolor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: 56,
  px: 2
};

export const cardTitleSx = {
  color: '#424242',
  fontSize: 16,
  fontWeight: 500
};

export const editButtonSx = {
  bgcolor: '#F5DDAE',
  border: '1px solid #E3C796',
  borderRadius: '4px',
  boxShadow: 'none',
  color: '#424242',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: '#F0D49B',
    borderColor: '#D9B36A',
    boxShadow: 'none'
  },

  '& .MuiButton-startIcon': {
    mr: 0.5
  }
};

export const providerContentSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 3,
  minHeight: 100,
  px: 2,
  py: 2
};

export const providerAvatarSx = {
  bgcolor: '#D7ECFA',
  border: '1px solid #8FC7ED',
  color: '#4A90D9',
  flexShrink: 0,
  fontSize: 20,
  fontWeight: 600,
  height: 68,
  width: 68
};

export const providerFieldsSx = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexWrap: 'wrap',
  gap: {
    xs: 2,
    lg: 5
  },
  minWidth: 0
};

export const providerFieldSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
};

export const providerWideFieldSx = {
};

export const providerIconSx = {
  color: '#4F91D5',
  flexShrink: 0,
  fontSize: 21
};

export const providerLabelSx = {
  color: '#757575',
  fontSize: 11,
  lineHeight: 1.3,
  mb: 0.25
};

export const providerValueSx = {
  color: '#424242',
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

export const passwordCardSx = {
  ...cardSx,
  mt: 2
};

export const passwordContentSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 5,
  minHeight: 60,
  px: 2,
  py: 2
};

export const usernameFieldSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
  minWidth: 210
};

export const changePasswordButtonSx = {
  color: '#C78421',
  fontSize: 13,
  fontWeight: 500,
  p: 0,
  textDecoration: 'underline',
  textTransform: 'none',

  '&:hover': {
    bgcolor: 'transparent',
    color: '#A76813',
    textDecoration: 'underline'
  },

  '& .MuiButton-startIcon': {
    mr: 0.75
  }
};

export const dialogPaperSx = {
  borderRadius: '8px',
  maxHeight: 'calc(100vh - 32px)',
  width: 600
};

export const passwordDialogPaperSx = {
  ...dialogPaperSx,
  width: 600
};

export const dialogTitleSx = {
  bgcolor: '#F8FAFD',
  borderBottom: '1px solid #E0E0E0',
  px: 2,
  py: 1.5
};

export const dialogHeaderSx = {
  alignItems: 'flex-start',
  display: 'flex',
  justifyContent: 'space-between'
};

export const dialogTitleTextSx = {
  color: '#424242',
  fontSize: 17,
  fontWeight: 500,
  lineHeight: 1.3
};

export const dialogSubtitleSx = {
  color: '#424242',
  fontSize: 12,
  mt: 0.25
};

export const dialogCloseButtonSx = {
  color: '#424242',
  mt: -0.25
};

export const dialogContentSx = {
  px: 2,
  py: 2,
};

export const dialogFormSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2.5,
  pt:2,
  pb:0
};

export const fieldSx = {
  '& .MuiInputBase-root': {
    borderRadius: '4px',
    fontSize: 14,
  },

  '& .MuiInputLabel-root': {
    color: '#757575',
    fontSize: 13
  },

  '& .MuiOutlinedInput-input': {
    color: '#616161',
    px: 1.5,
    py: 1.5
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#BDBDBD'
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#9E9E9E'
  }
};

export const dialogActionsSx = {
  borderTop: '1px solid #E0E0E0',
  gap: 1,
  px: 2,
  py: 2
};

export const cancelButtonSx = {
  color: '#616161',
  fontSize: 13,
  fontWeight: 500
};

export const saveButtonSx = {
  bgcolor: '#5697D4',
  borderRadius: '4px',
  boxShadow: 'none',
  color: '#FFFFFF',
  fontSize: 13,
  fontWeight: 500,

  '&:hover': {
    bgcolor: '#5697D4',
    boxShadow: 'none'
  },

  '&.Mui-disabled': {
    bgcolor: '#EEEEEE',
    color: '#BDBDBD'
  }
};

export const changePasswordSubmitSx = {
  ...saveButtonSx,
  minWidth: 178
};

export const visibilityButtonSx = {
  color: '#9E9E9E',
  fontSize:18
};